wbApp.controller('CompensationTransferDetailCtrl', ['$scope', '$modal', 'compensationTransferSvc',
function ($scope, $modal, compensationTransferSvc) {

    $scope.initialized = false;
    $scope.model = compensationTransferSvc.createEmptyModel($scope.sourceSemesterID);

    compensationTransferSvc.initilizeModelAsync($scope.model)
        .then(function (model) {
            $scope.initialized = true;
            if (model.isNew) {
                $scope.model.compensationTransfer.destinationSemesterID = null;
            }
        });

    $scope.onDestinationSemesterChange = function (destinationSemesterID) {
        compensationTransferSvc.initilizeModelAsync($scope.model, destinationSemesterID)
        .then(function (model) {
            $scope.initialized = true;            
        });
    };

    $scope.onTransferToAmendTypeChange = function (transferToAmendType) {
        compensationTransferSvc.changeTransferToAmendType($scope.model, transferToAmendType);
    }

    $scope.onMaximumTransferredAmendsChange = function (maximumTransferredAmends) {
        compensationTransferSvc.changeMaximumTransferredAmends($scope.model, maximumTransferredAmends);
    }

    $scope.onTransferRemainingPreAmendsChange = function (transferRemainingPreAmends) {
        compensationTransferSvc.changeTransferRemainingPreAmends($scope.model, transferRemainingPreAmends);
    }

    $scope.onTransferRemainingTimeBoundAmendsChange = function (transferRemainingTimeBoundAmends) {
        compensationTransferSvc.changeTransferRemainingTimeBoundAmends($scope.model, transferRemainingTimeBoundAmends);
    }

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "setting/semesters/compensation-transfer-detail-main-tab.html"
        },
        {
            title: "TXT_TITLE_COMPENSATION_TRANSFER_DETAIL",
            template: "setting/semesters/compensation-transfer-detail-transfer-tab.html"
        }
    ];

    $scope.detailTabs.activeTab = 0;

    $scope.onNextBtnClick = function () {
        $scope.detailTabs.activeTab = 1;
    }

    $scope.onBackBtnClick = function () {
        $scope.detailTabs.activeTab = 0;
    }

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        sortInfo: { fields: ['studentFullName'], directions: ['asc'] },
        columnDefs: [{ field: 'studentFullName', displayName: "TXT_LBL_STUDENT", sort: 'locale' },
                     { field: 'sourceCourseFullName', displayName: "TXT_LBL_SOURCE_COURSE", sort: 'locale', width: '230px' },
                     { field: 'optionsCount', displayName: '', width: '25px', align: 'right' },
                     { field: 'destinationCourseFullName', displayName: "TXT_LBL_DESTINATION_COURSE", sort: 'locale', width: '230px' },
                     { field: 'availableAmends', displayName: "Náh", width: '40px', align: 'right' },
                     { field: 'transferredPreAmends', displayName: "Pře", width: '40px', align: 'right' },
                     { field: 'transferredTimeBoundAmends', displayName: "Čas", width: '40px', align: 'right' }
        ],
        disabledField: 'isPristine',
        disabledAreSelectable: true
    };

    $scope.errorGridOptions = {
        sortInfo: { fields: ['studentFullName'], directions: ['asc'] },
        columnDefs: [{ field: 'studentFullName', displayName: "TXT_LBL_STUDENT", sort: 'locale', width: '130px' },
                     { field: 'sourceCourseFullName', displayName: "TXT_LBL_SOURCE_COURSE", sort: 'locale', width: '200px' },
                     { field: 'destinationCourseFullName', displayName: "TXT_LBL_DESTINATION_COURSE", sort: 'locale', width: '200px' },
                     { field: 'error', displayName: "Chyba" }
        ],
        noCommandColumn:  true
    };

    $scope.isSaving = false;

    $scope.onCompensationTransferDetailSave = function (model) {

        $scope.isSaving = true;

        $scope.detailError = null;

        compensationTransferSvc.update(model, success, error);

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            if (data.errors && data.errors.length) {
                compensationTransferErrorModalPromise.$promise.then(function () {
                    compensationTransferErrorModalPromise.$scope.errors = data.errors;
                    compensationTransferErrorModalPromise.show();
                });
            } else {
                $scope.detailError = data;
            }
        }
    }

    $scope.onRowEdit = function (row) {
        compensationTransferDetailDialogPromise.$promise.then(function () {
            compensationTransferDetailDialogPromise.$scope.model = row
            compensationTransferDetailDialogPromise.show();
        });
    };

    var compensationTransferDetailDialogPromise = $modal({
        templateUrl: 'setting/semesters/compensation-transfer-detail-transfer-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var compensationTransferErrorModalPromise = $modal({
        templateUrl: 'setting/semesters/compensation-transfer-error-modal.html',
        show: false,
        scope: $scope.$new()
    });

}]);
